<script>
    import { t } from "../../../i18n";
</script>

<div class="tab-pane active" id="details" aria-labelledby="details-tab" role="tabpanel">
    <div class="border-bottom d-flex align-items-center flex-column pb-1">
        <img src="assets/theme/images/icon/pdf.png" alt="PDF" height="42" width="35" class="my-1">
        <p class="mt-2">15.3mb</p>
        <button class="btn btn-primary">{$t('files.download')}</button>
    </div>
    <div class="card-body pt-2">


        <label class="app-file-label">{$t('files.info')}</label>
        <div class="d-flex justify-content-between align-items-center mt-75">
            <p>{$t('files.type')}</p>
            <p class="font-weight-bold">PDF</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <p>{$t('files.size')}</p>
            <p class="font-weight-bold">15.6mb</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <p>{$t('files.location')}</p>
            <p class="font-weight-bold">Files > Documents</p>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <p>{$t('files.created')}</p>
            <p class="font-weight-bold">July 1, 2019</p>
        </div>
    </div>
</div>